import {Component, Element, h, Host, Listen, Prop} from "@stencil/core";
import {NavItemComponent} from "./nav-item/nav-item-component";
import {NavUtils} from "../../core/nav/utils/NavUtils";
import {NavItemTypeEnum} from "../../core/nav/domain/NavItemTypeEnum";
import {WebUtils} from "../../core/utils/WebUtils";
import {StringUtils} from "../../core/utils/StringUtils";

@Component({
    tag: 'snt-nav',
    styleUrl: "nav-component.scss",
    shadow: false
})
export class NavComponent {

    public static readonly TAG_NAME = "snt-nav";

    @Prop({reflect: true}) expander:string;
    @Prop({reflect: true}) separator:boolean;
    @Prop({reflect: true}) styleClasses:string = StringUtils.empty();
    
    @Element() element!: HTMLElement;

    @Listen("navItemEvent")
    handleNavItemEvent(event:CustomEvent) {
        const expanded = (event.target as HTMLSntNavItemElement).expanded;
        if(expanded) {
            this.collapseSiblingSubnavs((event.target as HTMLSntNavItemElement));
        }
    }

    componentDidLoad() {
        this.setActiveNavItem();
    }

    private setActiveNavItem() {
        const navItems:NodeListOf<HTMLSntNavItemElement> = this.element.querySelectorAll(NavItemComponent.TAG_NAME);
        if(navItems) {
            navItems.forEach((navItem:HTMLSntNavItemElement)=>{
                if(navItem.isType(NavItemTypeEnum.ACTION_LINK) && NavUtils.isCurrentPage(navItem)) {
                    navItem.toggleCurrent().then(null); //test
                }
            });
        }
    }

    private collapseSiblingSubnavs(currentSubnav: HTMLSntNavItemElement) {
        const expandedSubnavs = this.element.querySelectorAll(`${NavItemComponent.TAG_NAME}[expanded]`);
        expandedSubnavs.forEach((expandedSubnav:HTMLSntNavItemElement) => {
            if (expandedSubnav != currentSubnav) {
                expandedSubnav.collapse().then(null);
            }
        });
    }

    render() {

        return (
            <Host class={WebUtils.generateClasses(["navbar-nav"], this.styleClasses)} role="list">
                <slot></slot>
            </Host>
        )
    }
}
